import React, { useEffect, useState } from "react";
import { FormControl, Select, MenuItem, InputLabel } from "@mui/material";
import { getFacilities } from "../../service/endpoint-manager";
import { MAX_DROPDOWN_HEIGHT } from "../../types/micellinous-constants";

function UnitFilter({ selectedUnit, setSelectedUnit, units, setUnits }) {
  const fetchUnits = async () => {
    try {
      const facilitiesResponse = await getFacilities();
      if (
        facilitiesResponse &&
        facilitiesResponse.data &&
        facilitiesResponse.data.body
      ) {
        const unitsData = facilitiesResponse.data.body.flatMap(
          (facility) => facility.units
        );
        setUnits(unitsData);
      } else {
        console.error("Unexpected response structure:", facilitiesResponse);
      }
    } catch (error) {
      console.error("Error fetching units:", error);
    }
  };

  useEffect(() => {
    fetchUnits();
  }, [setUnits]);

  const handleUnitChange = (event) => {
    setSelectedUnit(event.target.value);
  };

  return (
    <FormControl style={{ width: "70%" }}>
      <InputLabel id="unit-select-label">Unit</InputLabel>
      <Select
        labelId="unit-select-label"
        id="unit-select"
        value={selectedUnit}
        onChange={handleUnitChange}
        MenuProps={{
          style: {
            maxHeight: MAX_DROPDOWN_HEIGHT,
          },
        }}
      >
        <MenuItem value="all">All</MenuItem>
        {units.map((unit) => (
          <MenuItem key={unit.id} value={unit.name}>
            {unit.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

export default UnitFilter;
